export const GET_LOCATION = "GET_LOCATION";
export const GET_LOCATION_ERROR = "GET_LOCATION_ERROR";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";

export const MAP_READY = "MAP_READY";
export const MAP_VIEWPORT_CHANGE = "MAP_VIEWPORT_CHANGE";
export const RESET_GYMS = "RESET_GYMS";

export const UPDATE_SEARCH_TERM = "UPDATE_SEARCH_TERM";
